import loadable from '@loadable/component';

export const RealhomesSiteWrapper = loadable(
  () => import(/* webpackChunkName: "realhomes-site" */ './RealhomesSiteWrapper'),
);
